import _extends from "@babel/runtime/helpers/extends";
import "core-js/modules/es.array.map.js";
import React from 'react';
import { useTranslation, Trans } from 'react-i18next';
import { isHelixOnlyHub } from 'utils/helix';
import config from 'utils/config';
import PageSection from 'components/PageSection';
import UserPageHeader from 'components/UserPageHeader';
import Heading from 'components/Heading';
import Stack from 'components/Stack';
import Card from 'components/Card';
import Text from 'components/Text';
import TextLink from 'components/TextLink';
import UserCalendarIntegration from 'components/UserCalendarIntegration';
export var HelixEmailLink = function HelixEmailLink(_ref) {
  var children = _ref.children;
  return /*#__PURE__*/React.createElement(TextLink, {
    href: "mailto:helix@5app.com"
  }, children);
};
export function HowHelixWorksText(_ref2) {
  var headingProps = _ref2.headingProps,
    stackProps = _ref2.stackProps;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Heading, _extends({
    as: "h3",
    size: "medium",
    mb: "m"
  }, headingProps), t('skills_empty_how_helix_works_title')), /*#__PURE__*/React.createElement(Stack, _extends({
    spacing: "s"
  }, stackProps), /*#__PURE__*/React.createElement(Trans, {
    i18nKey: "skills_empty_how_helix_works_text_1"
  }, "Helix will attend any meeting to which", /*#__PURE__*/React.createElement(HelixEmailLink, null, "helix@5app.com"), "is invited."), ['skills_empty_how_helix_works_text_2', 'skills_empty_how_helix_works_text_3', 'skills_empty_how_helix_works_text_4', 'skills_empty_how_helix_works_text_5'].map(function (key) {
    return /*#__PURE__*/React.createElement(Text, {
      key: key
    }, t(key));
  })));
}
export function HelixChangeMyMindText(_ref3) {
  var headingProps = _ref3.headingProps,
    stackProps = _ref3.stackProps;
  var _useTranslation2 = useTranslation(),
    t = _useTranslation2.t;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Heading, _extends({
    as: "h3",
    size: "medium",
    mb: "m"
  }, headingProps), t('skills_empty_mind_changed_title')), /*#__PURE__*/React.createElement(Stack, _extends({
    spacing: "s"
  }, stackProps), ['skills_empty_mind_changed_text_1', 'skills_empty_mind_changed_text_2', 'skills_empty_mind_changed_text_3', 'skills_empty_mind_changed_text_4'].map(function (key) {
    return /*#__PURE__*/React.createElement(Text, {
      key: key
    }, t(key));
  })));
}
function WelcomePage(_ref4) {
  var user = _ref4.user;
  var _useTranslation3 = useTranslation(),
    t = _useTranslation3.t;
  return /*#__PURE__*/React.createElement(PageSection, {
    flush: true
  }, /*#__PURE__*/React.createElement(Stack, {
    spacing: "l",
    maxWidth: 860,
    mb: "m",
    mt: isHelixOnlyHub ? 'm' : '0'
  }, user && /*#__PURE__*/React.createElement(UserPageHeader, user), /*#__PURE__*/React.createElement(Heading, {
    as: "h2"
  }, t('skills_empty_welcome_title')), /*#__PURE__*/React.createElement(Card, {
    p: "m"
  }, /*#__PURE__*/React.createElement(Heading, {
    as: "h3",
    size: "medium",
    mb: "m"
  }, t('skills_empty_get_started_title')), /*#__PURE__*/React.createElement(Stack, {
    spacing: "s"
  }, /*#__PURE__*/React.createElement(Text, null, t('skills_empty_get_started_text_1')), /*#__PURE__*/React.createElement(Trans, {
    i18nKey: "skills_empty_get_started_text_2"
  }, "It couldn\u2019t be easier \u2013 simply invite", /*#__PURE__*/React.createElement(HelixEmailLink, null, "helix@5app.com"), "to your next meeting and it will automatically start tracking your skills."), /*#__PURE__*/React.createElement(Text, null, t('skills_empty_get_started_text_3')))), /*#__PURE__*/React.createElement(Card, {
    p: "m"
  }, /*#__PURE__*/React.createElement(HowHelixWorksText, null)), /*#__PURE__*/React.createElement(Card, {
    p: "m"
  }, /*#__PURE__*/React.createElement(HelixChangeMyMindText, null)), config.userCalendarIntegration && /*#__PURE__*/React.createElement(Card, {
    p: "m"
  }, /*#__PURE__*/React.createElement(UserCalendarIntegration, null))));
}
export default WelcomePage;